import { zergApi } from "@/service/zerg";

class BankAccountService {

    async getBankAccounts(params) {
        try {
            const data = await zergApi.get("/treasury/bank-accounts/index", { params });
            return data;
        } catch (error) {
            throw error;
        }
    }
}

export default new BankAccountService();